import _ from 'underscore';
import { COMPARISON_RANGES } from '@bingads-webui/date-ranges';

const comparisonOptionMapping = {
  PreviousPeriod: COMPARISON_RANGES.PREVIOUS_PERIOD,
  SamePeriodLastYear: COMPARISON_RANGES.SAME_PERIOD_LAST_YEAR,
  LastMonth: COMPARISON_RANGES.LAST_MONTH, // new ui has this
};

export function getStateComparisonDateRangeOption(ComparisonDateRangeOption) {
  return ComparisonDateRangeOption ?
    comparisonOptionMapping[ComparisonDateRangeOption] :
    COMPARISON_RANGES.CUSTOM;
}

export function getSelectionComparisonDateRangeOption(stateOption) {
  return _.findKey(comparisonOptionMapping, value => value === stateOption);
}
